import { render, staticRenderFns } from "./AlertsContextMenuComponent.vue?vue&type=template&id=13829ec1&scoped=true"
import script from "./AlertsContextMenuComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./AlertsContextMenuComponent.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./AlertsContextMenuComponent.vue?vue&type=style&index=0&id=13829ec1&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13829ec1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13829ec1')) {
      api.createRecord('13829ec1', component.options)
    } else {
      api.reload('13829ec1', component.options)
    }
    module.hot.accept("./AlertsContextMenuComponent.vue?vue&type=template&id=13829ec1&scoped=true", function () {
      api.rerender('13829ec1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Navigation/AppBarToolbarItems/contextMenus/alerts/AlertsContextMenuComponent.vue"
export default component.exports